module.exports = __webpack_public_path__ + "img/1.76658f62.png";